import { useSearchParams } from 'react-router-dom';

export function useQueryParam(key) {
  const [params] = useSearchParams();

  return params.get(key);
}
